// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__fXji8","footer_left":"Footer_footer_left__QKIQt","footer_right":"Footer_footer_right__lJgfp"};